import type { Action } from 'state/actions';
import type { SecondaryQuotationType } from 'state/secondaryMarket/productSearch';
import { addOrReplaceKey, patchKey } from 'state/utils/collection';

import type { AstroProductMap } from './astroProduct.model';
import { initialAstroProductMap, mapAstroProductClientsToISalesCounterpart } from './astroProduct.model';

export function legacyProductReducer(state: AstroProductMap = initialAstroProductMap, action: Action): AstroProductMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_ASTRO_PRODUCT_FETCH_REQUESTED':
      return addOrReplaceKey(state, action.isin, { isLoading: true, hasError: false, data: null });
    case 'SECONDARY_MARKET_ASTRO_PRODUCT_FETCHED':
      return patchKey(state, action.isin, () => ({
        isLoading: false,
        hasError: false,
        data: {
          ...action.data,
          quotationType: mapPriceDefintionToQuotationType(action.data.priceDefinition),
          clients: mapAstroProductClientsToISalesCounterpart(action.data.clients),
          lifecycleUrl: action.data.valuationInformations?.url,
        },
      }));
    case 'SECONDARY_MARKET_ASTRO_PRODUCT_FETCH_PRODUCT_NOT_FOUND':
      return patchKey(state, action.isin, () => ({ isLoading: false, hasError: true, data: null }));
    case 'SECONDARY_MARKET_ASTRO_PRODUCT_FETCH_FAILED':
      return patchKey(state, action.isin, () => ({ isLoading: false, hasError: true, data: null }));
    default:
      return state;
  }
}

function mapPriceDefintionToQuotationType(
  priceDef?: Uppercase<SecondaryQuotationType>,
): SecondaryQuotationType | undefined {
  if (priceDef === undefined) {
    return;
  }
  const mapType: Record<Uppercase<SecondaryQuotationType>, SecondaryQuotationType> = {
    CLEAN: 'Clean',
    DIRTY: 'Dirty',
  };
  return mapType[priceDef];
}
